<template>
<transition name="fade">
  <div class="app-cookie-bar" v-if="!inApp" v-show="showBar && !$store.state.currentGame.gameStarted">
    <a :href="`/cookie/${lang}.html`">{{$translate('layout').cookies}}</a>
    <a :href="`https://www.gucci.com/documents/legal/privacy/${lang}.pdf`" target="_blank" rel="noopener">{{$translate('layout').privacy}}</a>
  </div>
</transition>
</template>

<script>
import { inApp, getLang } from '@/scripts/utils';

export default {
  name: 'AppCookiebar',

  data() {
    return {
      showBar: true,
      inApp: inApp(),
      lang: getLang(),
    };
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.app-cookie-bar {
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  padding: 20px 10px;

  text-align: center;

  z-index: 100;
  font-size: 10px;


  @include mq($until: ipadP) {
    font-size: 12px;
  }

  @include mq(ipadP) {
    left: 50%;
    bottom: 20px;
    width: unset;
    padding: 15px 50px;

    transform: translateX(-50%);
  }

  .underline__blue {
    font-weight: 800;

    &::after {
      bottom: -10px;
    }
  }

  &__button {
    margin-left: 20px;
    padding: 10px 15px;

    background-color: $color-red;
    border-radius: 50%;
    color: $color-bg;
    font-weight: 800;

    @include mq(ipadP) {
      margin-left: 5vw;
      padding: 20px 35px;
    }
  }
}
</style>
